import { FC } from "react";
import { Typography } from "antd";

const TrialAnalyticsTab: FC = () => {
    return (
        <div>
            <Typography.Title level={4}>Trial Analytics</Typography.Title>
            <Typography.Text>Trial-specific insights will be displayed here.</Typography.Text>
        </div>
    );
};

export default TrialAnalyticsTab;
